import createIcon from '@/lib/create-icon'

const SnookerIcon = createIcon(
  <svg
    id='filled-icon'
    xmlns='http://www.w3.org/2000/svg'
    width='18'
    height='18'
    viewBox='0 0 46 46'
    fill='none'
  >
    <path
      stroke='none'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M23.4396 6.71251C14.2015 6.71251 6.71251 14.2015 6.71251 23.4396C6.71251 32.6778 14.2015 40.1668 23.4396 40.1668C32.6778 40.1668 40.1668 32.6778 40.1668 23.4396C40.1668 14.2015 32.6778 6.71251 23.4396 6.71251ZM4 23.4396C4 12.7034 12.7034 4 23.4396 4C34.1758 4 42.8793 12.7034 42.8793 23.4396C42.8793 34.1758 34.1758 42.8793 23.4396 42.8793C12.7034 42.8793 4 34.1758 4 23.4396Z'
      fill='url(#paint0_linear_5444_558)'
    />
    <path
      stroke='none'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M23.4396 6.71251C14.2015 6.71251 6.71251 14.2015 6.71251 23.4396C6.71251 32.6778 14.2015 40.1668 23.4396 40.1668C32.6778 40.1668 40.1668 32.6778 40.1668 23.4396C40.1668 14.2015 32.6778 6.71251 23.4396 6.71251ZM4 23.4396C4 12.7034 12.7034 4 23.4396 4C34.1758 4 42.8793 12.7034 42.8793 23.4396C42.8793 34.1758 34.1758 42.8793 23.4396 42.8793C12.7034 42.8793 4 34.1758 4 23.4396Z'
      fill='white'
      fillOpacity='0.04'
    />
    <path
      stroke='none'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M23.4396 6.71251C14.2015 6.71251 6.71251 14.2015 6.71251 23.4396C6.71251 32.6778 14.2015 40.1668 23.4396 40.1668C32.6778 40.1668 40.1668 32.6778 40.1668 23.4396C40.1668 14.2015 32.6778 6.71251 23.4396 6.71251ZM4 23.4396C4 12.7034 12.7034 4 23.4396 4C34.1758 4 42.8793 12.7034 42.8793 23.4396C42.8793 34.1758 34.1758 42.8793 23.4396 42.8793C12.7034 42.8793 4 34.1758 4 23.4396Z'
      fill='url(#paint1_radial_5444_558)'
      fillOpacity='0.6'
    />
    <path
      stroke='none'
      d='M33.8179 23.4396C33.8179 29.1714 29.1714 33.8179 23.4396 33.8179C17.7078 33.8179 13.0613 29.1714 13.0613 23.4396C13.0613 17.7078 17.7078 13.0613 23.4396 13.0613C29.1714 13.0613 33.8179 17.7078 33.8179 23.4396Z'
      fill='url(#paint2_linear_5444_558)'
    />
    <path
      stroke='none'
      d='M33.8179 23.4396C33.8179 29.1714 29.1714 33.8179 23.4396 33.8179C17.7078 33.8179 13.0613 29.1714 13.0613 23.4396C13.0613 17.7078 17.7078 13.0613 23.4396 13.0613C29.1714 13.0613 33.8179 17.7078 33.8179 23.4396Z'
      fill='white'
      fillOpacity='0.04'
    />
    <path
      stroke='none'
      d='M33.8179 23.4396C33.8179 29.1714 29.1714 33.8179 23.4396 33.8179C17.7078 33.8179 13.0613 29.1714 13.0613 23.4396C13.0613 17.7078 17.7078 13.0613 23.4396 13.0613C29.1714 13.0613 33.8179 17.7078 33.8179 23.4396Z'
      fill='url(#paint3_radial_5444_558)'
      fillOpacity='0.6'
    />
    <path
      stroke='none'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M23.4396 30.9875C27.6082 30.9875 30.9875 27.6082 30.9875 23.4396C30.9875 19.2711 27.6082 15.8918 23.4396 15.8918C19.2711 15.8918 15.8918 19.2711 15.8918 23.4396C15.8918 27.6082 19.2711 30.9875 23.4396 30.9875ZM23.4396 33.8179C29.1714 33.8179 33.8179 29.1714 33.8179 23.4396C33.8179 17.7078 29.1714 13.0613 23.4396 13.0613C17.7078 13.0613 13.0613 17.7078 13.0613 23.4396C13.0613 29.1714 17.7078 33.8179 23.4396 33.8179Z'
      fill='url(#paint4_linear_5444_558)'
    />
    <path
      stroke='none'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M23.4396 30.9875C27.6082 30.9875 30.9875 27.6082 30.9875 23.4396C30.9875 19.2711 27.6082 15.8918 23.4396 15.8918C19.2711 15.8918 15.8918 19.2711 15.8918 23.4396C15.8918 27.6082 19.2711 30.9875 23.4396 30.9875ZM23.4396 33.8179C29.1714 33.8179 33.8179 29.1714 33.8179 23.4396C33.8179 17.7078 29.1714 13.0613 23.4396 13.0613C17.7078 13.0613 13.0613 17.7078 13.0613 23.4396C13.0613 29.1714 17.7078 33.8179 23.4396 33.8179Z'
      fill='white'
      fillOpacity='0.04'
    />
    <path
      stroke='none'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M23.4396 30.9875C27.6082 30.9875 30.9875 27.6082 30.9875 23.4396C30.9875 19.2711 27.6082 15.8918 23.4396 15.8918C19.2711 15.8918 15.8918 19.2711 15.8918 23.4396C15.8918 27.6082 19.2711 30.9875 23.4396 30.9875ZM23.4396 33.8179C29.1714 33.8179 33.8179 29.1714 33.8179 23.4396C33.8179 17.7078 29.1714 13.0613 23.4396 13.0613C17.7078 13.0613 13.0613 17.7078 13.0613 23.4396C13.0613 29.1714 17.7078 33.8179 23.4396 33.8179Z'
      fill='url(#paint5_radial_5444_558)'
      fillOpacity='0.6'
    />
    <path
      stroke='none'
      d='M23.6594 26.9938C21.5762 26.9938 20.4893 26.2352 20.4893 24.82V24.5143C20.4893 23.7104 20.9082 23.1896 21.7686 22.9066C20.9421 22.6462 20.5572 22.182 20.5572 21.4121V21.0725C20.5572 19.7025 21.6214 18.978 23.6594 18.978C25.7086 18.978 26.7842 19.7025 26.7842 21.0725V21.4121C26.7842 22.182 26.3879 22.6462 25.5614 22.9066C26.4219 23.1896 26.8408 23.7104 26.8408 24.5143V24.82C26.8408 26.2578 25.7426 26.9938 23.6594 26.9938ZM23.6594 20.5404C23.1612 20.5404 22.9008 20.7555 22.9008 21.1291V21.6386C22.9008 22.0122 23.1612 22.216 23.6594 22.216C24.1688 22.216 24.4406 22.0122 24.4406 21.6386V21.1291C24.4406 20.7328 24.1688 20.5404 23.6594 20.5404ZM23.6594 25.4314C24.1915 25.4314 24.4859 25.2049 24.4859 24.8087V24.3105C24.4859 23.9142 24.1915 23.6991 23.6594 23.6991C23.1272 23.6991 22.8442 23.9142 22.8442 24.3105V24.8087C22.8442 25.2162 23.1272 25.4314 23.6594 25.4314Z'
      fill='#221825'
    />
    <defs>
      <linearGradient
        id='paint0_linear_5444_558'
        x1='4'
        y1='4'
        x2='48.445'
        y2='34.8646'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#E90083' />
        <stop offset='1' stopColor='#FF6864' />
      </linearGradient>
      <radialGradient
        id='paint1_radial_5444_558'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(23.4396 42.8793) scale(19.4396 19.7988)'
      >
        <stop stopColor='white' />
        <stop offset='1' stopColor='#754660' stopOpacity='0' />
      </radialGradient>
      <linearGradient
        id='paint2_linear_5444_558'
        x1='4'
        y1='4'
        x2='48.445'
        y2='34.8646'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#E90083' />
        <stop offset='1' stopColor='#FF6864' />
      </linearGradient>
      <radialGradient
        id='paint3_radial_5444_558'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(23.4396 42.8793) scale(19.4396 19.7988)'
      >
        <stop stopColor='white' />
        <stop offset='1' stopColor='#754660' stopOpacity='0' />
      </radialGradient>
      <linearGradient
        id='paint4_linear_5444_558'
        x1='4'
        y1='4'
        x2='48.445'
        y2='34.8646'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#E90083' />
        <stop offset='1' stopColor='#FF6864' />
      </linearGradient>
      <radialGradient
        id='paint5_radial_5444_558'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(23.4396 42.8793) scale(19.4396 19.7988)'
      >
        <stop stopColor='white' />
        <stop offset='1' stopColor='#754660' stopOpacity='0' />
      </radialGradient>
    </defs>
  </svg>,
  'SnookerIcon'
)

export default SnookerIcon
